<template>

    <section class="gui-txt-mask" v-if="meritList.length > 0">
        <div class="gui">
            <div class="gui-content">
                <ul class="gui-list" v-for="(item, $index) in meritList" :key="$index">
                    <li>
                        <i class="icon">
                            <small>NEW</small>
                        </i>
                        <a @click="openDocDetail(item)">{{ item.title }}</a>
                    </li>
                </ul>

            </div>
            <a class="gui-more" @click="openDocAll()">全部公告
                <i class="el-icon-arrow-right">
                </i>
            </a>
        </div>
    </section>
</template>

<script>
    import menuList from "../common/navConfig";

    export default {
        data() {
            return {
                meritList: [],
                categoryId: "",
                menu: "",
                id: "",
                newId:'',
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            // 获取详情
            getList() {
                this.$axios.get("/ajax/guidance/document/broadcast/list").then(res => {
                    this.meritList = res.data.data.list;
                    this.newId=this.meritList[0].id;
                });
            },
            // 获取详情
            openDocDetail(item) {
                let url = "/generic-doc/5" + '?menu=' + localStorage.getItem("menuPT") + '&id=' + item.id;
                return this.$router.push({
                    path: url
                });
            },
            // 获取详情
            openDocAll(item) {
                let url = "/generic-doc/5" + '?menu=' + localStorage.getItem("menuPT")+'&id='+this.newId;
                return this.$router.push({
                    path: url
                });
            },
        }
    };
</script>

<style lang="scss" scoped>

    .gui-txt-mask {
        height: 40px;
        width: 100%;
        background-color: #fff;
        border-bottom: 1px solid #e6f0f5
    }

    .gui-txt-mask .gui {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 100%;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        font-size: 14px;
        color: #96a9b3;
        width: 1000px;
        margin: 0 auto
    }

    .gui-txt-mask .gui-content {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 100%;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-flex: 1;
        -ms-flex: 1 0 auto;
        flex: 1 0 auto
    }

    .gui-txt-mask .gui-list {
        margin: 0;
        padding: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        vertical-align: middle
    }

    .gui-txt-mask .gui-list li {
        margin-right: 45px;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        white-space: nowrap;
        max-width: 400px;
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: pointer
    }

    .gui-txt-mask .gui-list .icon {
        display: inline-block;
        width: 40px;
        border-radius: 80px;
        background-color: #24b47e;
        margin-right: 5px;
        color: #fff;
        font-size: 12px;
        text-align: center
    }

    .gui-txt-mask .gui-list .icon > small {
        display: block;
        -webkit-transform: scale(0.8);
        transform: scale(0.8)
    }

    .gui-txt-mask .gui-list > a {
        overflow: hidden;
        color: inherit
    }

    .gui-txt-mask .gui-more {
        display: block;
        color: #000;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        cursor: pointer;
        color: inherit
    }

    .gui-txt-mask .gui-more i {
        font-size: 12px;
        color: #999
    }

    .merit-box-item {
        padding: 80px 20px;
    }

    .merit-item {
        text-align: center;
        transition: all 0.3s;
        -moz-transition: all 0.3s;
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;

        .merit-img {
            width: 96px;
            height: 90px;
            vertical-align: top;
        }

        .merit-name {
            margin-top: 34px;
            color: #393939;
            font-size: 18px;
            font-weight: bold;
        }

        .merit-desc {
            margin-top: 22px;
            color: #000;
            font-size: 12px;
            line-height: 22px;
        }

        &:hover {
            transform: scale(1.2);

            .merit-name {
                color: #f16622;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/index/newdoc.vue